<template>
  <SwitchGroup as="div" class="flex items-center justify-between">
    <span class="flex flex-grow flex-col" v-if='!props.hideLabel'>
      <SwitchLabel as="span" class="text-sm font-medium leading-6 text-gray-900" passive :for='labelId'>{{ props.label }}</SwitchLabel>
    </span>
    <Switch :id='labelId' v-model="model" :class="[model ? 'bg-jananavy-900' : 'bg-gray-200', 'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-jananavy-900 focus:ring-offset-2']">
      <span aria-hidden="true" :class="[model ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out']" />
    </Switch>
  </SwitchGroup>
</template>

<script setup>

import { nanoid } from 'nanoid';

import { ref, computed } from 'vue';
import { Switch, SwitchDescription, SwitchGroup, SwitchLabel } from '@headlessui/vue';

const model = defineModel();

const props = defineProps({
  label: String,
  hideLabel: Boolean,
  labelId: String
});

const labelId = computed(() => {
  return props.labelId || nanoid();
});

</script>